import { z } from 'zod'

export const LocaleFormatSchema = z.string().regex(/^[a-z]{2,3}(-[A-Z]{2})?$/, {
  message: "Invalid locale format. Expected format: 'en' or 'en-US'.",
})

export const SUPPORTED_LOCALES = ['en-GB', 'en-US', 'es-ES'] as const

export const SupportedLocaleEnum = z.enum(SUPPORTED_LOCALES)

export type SupportedLocale = z.infer<typeof SupportedLocaleEnum>
